import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { logoutStaff } from "../../redux/staffSlice";
import pictoAccueil from "../../img/picto-accueil.png";

const HeaderBar = () => {
  const dispath = useDispatch();
  const staffLogged = useSelector((state) => state.staff.isLogged);

  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const location = useLocation();
  const isHome = location.pathname === "/";

  const [links, setLinks] = useState([
    { name: "Accueil", href: "/" },
    { name: "La Team", href: "/equipe" },
    { name: "Agenda", href: "/agenda" },
    { name: "Groupes", href: "/groupes" },
    { name: "Carte Cadeau", href: "/cadeau" },
    { name: "Contact", href: "/contact" },
    { name: "Réserver", href: "/reservations" },
  ]);

  /* useEffect(() => {
    setLinks((prev) => {
      const hasConsole = prev.some((item) => item.name === "Console");
      if (staffLogged && !hasConsole) {
        return [...prev, { name: "Console", href: "/administration" }];
      }
      if (!staffLogged && hasConsole) {
        return prev.filter((item) => item.name !== "Console");
      }
      return prev;
    });
  }, [staffLogged]);*/

  const leftLinks = useMemo(() => links.slice(0, 4), [links]);
  const rightLinks = useMemo(() => links.slice(4), [links]);

  const logoutHandler = () => {
    dispath(logoutStaff());
    navigate("/", { replace: true, relative: "path" });
  };

  const staffButton = () => {
    return !staffLogged ? (
      <button
        className="px-4 py-2 bg-[#f7bfd8c9] text-white rounded-lg hover:bg-orange-700 transition"
        onClick={() => navigate("login", { replace: true, relative: "route" })}
      >
        Se connecter
      </button>
    ) : (
      <button
        className="px-4 py-2 bg-[#f3a3c7] text-white rounded-lg hover:bg-orange-700 transition"
        onClick={logoutHandler}
      >
        logout
      </button>
    );
  };

  return (
    <nav className={`w-full  bg-[#f7bfd8c0] shadow-md z-50 ${isHome ? "relative" : ""}`}>
      <div className="max-w-7xl mx-auto px-4 py-3">
        {/* Desktop layout */}
        <div className="hidden md:flex items-center justify-between gap-6">
          <div className="flex flex-1 justify-between space-x-6 mr-12">
            {leftLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-orange-400 hover:text-orange-700 transition text-lg font-semibold"
              >
                {link.name}
              </a>
            ))}
          </div>

          <div className="flex-shrink-0 flex justify-center">
            <a href="/">
              <img
                src={pictoAccueil}
                alt="Accueil Mood"
                className="h-14 w-auto"
              />
            </a>
          </div>

          <div className="flex flex-1 justify-between items-center space-x-6 ml-12">
            {rightLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-orange-400 hover:text-orange-700 transition text-lg font-semibold"
              >
                {link.name}
              </a>
            ))}

          </div>
        </div>

        {/* Mobile layout */}
        <div className="md:hidden flex items-center justify-between">
          <a href="/" className="flex items-center">
            <img src={pictoAccueil} alt="Accueil Mood" className="h-12 w-auto" />
          </a>

          <button
            aria-label="Menu"
            onClick={() => setMenuOpen(!menuOpen)}
            className="relative w-8 h-6 flex flex-col justify-between items-center z-50 focus:outline-none"
          >
            <span
              className={`block w-full h-[2px] bg-orange-700 rounded transform transition-all duration-700 ${menuOpen ? "translate-y-2 rotate-45" : "translate-y-0 rotate-0"}`}
            />
            <span
              className={`block w-full h-[2px] bg-orange-700 rounded transform transition-all duration-700 ${menuOpen ? "opacity-0 -translate-x-2" : "opacity-100 translate-x-0"}`}
            />
            <span
              className={`block w-full h-[2px] bg-orange-700 rounded transform transition-all duration-700 ${menuOpen ? "-translate-y-4 -rotate-45" : "translate-y-0 rotate-0"}`}
            />
          </button>
        </div>
      </div>

      {/* Mobile full-screen menu */}
      <div
        onClick={() => setMenuOpen(false)}
        className={`fixed inset-0 bg-[#F7BFD8] flex items-center justify-center transition-all duration-300 ${menuOpen ? "opacity-100 visible z-40" : "opacity-0 invisible pointer-events-none"}`}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className="flex flex-col items-center justify-center space-y-8 text-xl font-medium px-6"
        >
          {links.map((link) => (
            <a
              key={link.name}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="text-orange-400 hover:text-orange-700 transition text-2xl"
            >
              {link.name}
            </a>
          ))}
          {/*staffButton()*/}
          </div>
      </div>
    </nav>
  );
};

export default HeaderBar;
